import {
	CreateEditProductPayload,
	ProductList,
	ProductResult,
	ProductSegmentResult,
	ProductTranslationPayload,
	SingleProduct,
} from "@/modules/product";
import { axiosInstance } from "../common";
import { ApiResponse } from "@/shared/types/server-response";

const baseUrl = "catalog/product";
const baseUrlProductSegment = "catalog/product-segment";

export const getProducts = async (
	filter: Record<string, string | number | boolean>,
	withPagination = true
): Promise<ProductList> => {
	const page = filter?.page ? filter.page : 1;
	const limit = 10;
	const filterProductName = filter.productName ? `&productName=${filter.productName}` : "";

	const { data } = await axiosInstance().get<ProductList>(
		`${baseUrl}?page=${page}&limit=${limit}&withPagination=${withPagination}${filterProductName}`
	);
	return data;
};

export const getProduct = async (id: number): Promise<ProductResult> => {
	const { data } = await axiosInstance().get<SingleProduct>(`${baseUrl}/${id}`);
	return data.result;
};

export const deleteManyProduct = async (ids: number[]) => {
	const { data } = await axiosInstance().post<SingleProduct>(`${baseUrl}/soft-delete-many`, {
		productIds: ids,
	});
	return data.result;
};

export const addProductLang = async (payload: ProductTranslationPayload) => {
	const { productId, ...rest } = payload;
	const { data } = await axiosInstance().post<ApiResponse<ProductTranslationPayload>>(
		`${baseUrl}/${productId}/translation`,
		{ ...rest }
	);
	return data.result;
};

export const updateProductLang = async (payload: ProductTranslationPayload) => {
	const { productId, ...rest } = payload;
	const { data } = await axiosInstance().patch<ApiResponse<ProductTranslationPayload>>(
		`${baseUrl}/${productId}/translation`,
		{ ...rest }
	);
	return data.result;
};

export const deleteProductLang = async (productId: number, locale: string) => {
	const { data } = await axiosInstance().delete<ApiResponse<ProductTranslationPayload>>(
		`${baseUrl}/${productId}/translation/${locale}`
	);
	return data.result;
};

export const getProductSegments = async () => {
	const { data } = await axiosInstance().get<ApiResponse<ProductSegmentResult[]>>(
		`${baseUrlProductSegment}?page=1&limit=50&paginate=true`
	);
	return data.result;
};

export const createProduct = async (payload: CreateEditProductPayload) => {
	const { data } = await axiosInstance().post<ApiResponse<ProductResult>>(`${baseUrl}`, payload);

	return data.result;
};

export const updateProduct = async (id: number, payload: CreateEditProductPayload) => {
	const { data } = await axiosInstance().patch<ApiResponse<ProductResult>>(`${baseUrl}/${id}`, payload);

	return data.result;
};
